import React, { useEffect, useState } from 'react';
import { Routes, Route } from 'react-router-dom';

import Navigation from '../Page/Navigation';
import Leaderboard from './Leaderboard/Leaderboard';

function Home () 
{
    const [ showFloatingFooter, setShowFloatingFooter ] = useState ( true );

    useEffect(() => {
        const handleScroll = () => {
        const scrollY = window.scrollY;
        const windowHeight = window.innerHeight;
        const documentHeight = document.body.scrollHeight;

        // When the user is near the bottom (within 100px)
        const nearBottom = scrollY + windowHeight >= documentHeight - 100;

        setShowFloatingFooter(!nearBottom);
        };

        window.addEventListener('scroll', handleScroll);

        // Call once on mount to set the initial state
        handleScroll();

        return () => {
        window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    
    return <>
                <Routes>
                    <Route path="/" element={ <Leaderboard /> } />
                </Routes>
                <Navigation />
                
                {showFloatingFooter && (
                    <div id="floating-footer" className="w-full flex flex-col fixed bottom-0 left-0 right-0">
                        <div className="w-full max-w-screen-md m-auto bg-pgteal shadow-pgTopShadow">
                            <Navigation />
                        </div>
                    </div> )}
            </>
}

export default Home;
